import { useCallback, useContext } from 'react'
import { useUnmount } from 'react-use'
import { trigger } from '../../../lib/events'
import { Context } from '../../../context'
import { config } from '../../../config'
import { Moises } from '../../../lib/cli'
import { getStemsByInstrument } from './utils'

import { UseInstrumentsSeparateCustom } from '../../use-instruments-separate-custom'

interface UseCustomTracks {
  onUpdateTrack(): void
}

interface Props {
  trackId: string
  methods: UseInstrumentsSeparateCustom
}

const MoisesCLI = Moises({ apiEndpoint: config.api.endpoint })

export const useUpdateTrack = ({
  trackId,
  methods
}: Props): UseCustomTracks => {
  const { userToken } = useContext(Context)

  const {
    instruments,
    selectedInstruments: instrumentsSelected,
    clearInstrumentsSelected
  } = methods

  useUnmount(() => {
    clearInstrumentsSelected()
  })

  const addOperation = useCallback(
    async (name: string, params: { stems: string[] }): Promise<void> => {
      MoisesCLI.auth(userToken)

      await MoisesCLI.addOperationsToTask({
        trackId,
        operations: [
          {
            name,
            params
          }
        ]
      })

      await new Promise((resolve) => setTimeout(resolve, 500))

      trigger('revalidate:tasks')
    },
    [userToken, trackId]
  )

  const onUpdateTrack = useCallback<UseCustomTracks['onUpdateTrack']>(() => {
    const params = {
      stems: getStemsByInstrument(instruments, instrumentsSelected)
    }
    addOperation('SEPARATE_CUSTOM', params)
  }, [instruments, instrumentsSelected, addOperation])

  return {
    onUpdateTrack
  }
}
